import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { push } from 'redux-first-history';
import routes from '../../routes';
import {
  NewsContainer,
  NewsImage,
  NewsLabel,
  NewsTitle,
  NewsDetails,
  NewsDate,
  NewsHeader
} from './styles';
import Mosvita from '../../ui/typography/mosvita';
import theme from '../../ui/theme';

const NewsCard = ({ news, isRecent, isInterest, pushUrl }) => {
  const { id, image, title, date, category } = news;

  const goToNewsDetails = () => {
    pushUrl(`${routes.news.path}/${id}`);
  };

  return (
    <NewsContainer
      isRecent={isRecent}
      isInterest={isInterest}
      onClick={goToNewsDetails}
    >
      <NewsImage src={image.url} />
      <NewsDetails>
        <NewsHeader>
          {isRecent ? (
            <NewsLabel>
              <Mosvita htmlAttribute="span" type="newsLabel">
                News
              </Mosvita>
            </NewsLabel>
          ) : (
            <NewsLabel>
              <Mosvita
                htmlAttribute="span"
                type="newsLabel"
                configuration={{ color: theme.colors.secondary }}
              >
                {category}
              </Mosvita>
            </NewsLabel>
          )}
          <NewsDate>
            <Mosvita htmlAttribute="span" type="newsDate">
              {moment(new Date(date * 1000)).format('DD-MM-YYYY')}
            </Mosvita>
          </NewsDate>
        </NewsHeader>
        <NewsTitle>
          <Mosvita htmlAttribute="span" type="newsTitle">
            {title}
          </Mosvita>
        </NewsTitle>
      </NewsDetails>
    </NewsContainer>
  );
};

NewsCard.propTypes = {
  news: PropTypes.object,
  isRecent: PropTypes.bool,
  isInterest: PropTypes.bool,

  // HOC (connect, dispatch)
  pushUrl: PropTypes.func.isRequired
};

NewsCard.defaultProps = {
  news: {},
  isRecent: false
};

export default connect(
  () => ({}),
  dispatch => ({
    pushUrl: url => dispatch(push(url))
  })
)(NewsCard);
